import { createCRUDHook } from './createCRUDHook';
import { WidgetDto } from 'utils/models';
import { CancelToken } from 'axios';
import { WIDGET } from './apiEndPoints';

interface WidgetCustomOperations {
  getWidgetData: (cancelToken?: CancelToken) => Promise<WidgetDto[]>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  WidgetDto,
  WidgetDto[],
  WidgetCustomOperations
>({
  entityName: 'Widget',
  endpoint: WIDGET,

  customOperations: (auth) => ({
    getWidgetData: async (cancelToken?: CancelToken): Promise<WidgetDto[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(WIDGET, cancelToken);
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const WidgetContext = Context;
export const useWidgetManager = useManager;
export const useWidget = useConsumer;
